import { AfterViewInit, Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { EpubViewerStore } from './state/epub-viewer.store';
import * as actions from './state/epub-viewer.actions';
import { ofType } from '@ngrx/effects';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'reader-core-epub-ui-viewer',
  templateUrl: './epub-viewer.component.html',
  styleUrls: ['./epub-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EpubViewerComponent implements AfterViewInit {
  @Input() readonly isDoubleSpread: boolean;
  @Input() readonly albumMode: boolean;

  @ViewChild('leftPageIframe') leftPageIframeRef: ElementRef;
  @ViewChild('rightPageIframe') rightPageIframeRef: ElementRef;
  @ViewChild('cloIframe') cloIframeRef: ElementRef;

  renderReady = false;

  get cloIframeDocument(): HTMLDocument {
    const iframe = this.cloIframe;
    return iframe?.contentDocument as HTMLDocument;
  }

  get cloIframe(): HTMLIFrameElement {
    return this.cloIframeRef && (this.cloIframeRef.nativeElement as HTMLIFrameElement);
  }

  get leftPageIframe(): HTMLIFrameElement {
    return this.leftPageIframeRef && (this.leftPageIframeRef.nativeElement as HTMLIFrameElement);
  }

  get rightPageIframe(): HTMLIFrameElement {
    return this.rightPageIframeRef && (this.rightPageIframeRef.nativeElement as HTMLIFrameElement);
  }

  constructor(private readonly epubViewerStore: EpubViewerStore) {
    this.epubViewerStore.actions$.pipe(
      ofType(actions.renderSinglePane, actions.renderDoublePane),
      takeUntilDestroyed(),
    ).subscribe(() => {
      this.renderReady = false;
    });

    this.epubViewerStore.actions$.pipe(
      ofType(actions.renderComplete),
      takeUntilDestroyed(),
    ).subscribe(() => {
      this.renderReady = true;
    });
  }

  ngAfterViewInit(): void {
    if (!(this.cloIframeRef || this.leftPageIframeRef || this.rightPageIframeRef)) {
      throw new Error('Unable to register iFrame(s)');
    }

    this.epubViewerStore.setCloIframe(this.cloIframe);

    this.epubViewerStore.setLeftIframe(this.leftPageIframe);
    this.epubViewerStore.setRightIframe(this.rightPageIframe);
  }

  // TODO delete this function once iframe service is ready
  scrollToElementById(elementId, speed?, offset?): null {
    const doc = this.cloIframeDocument;
    const element = doc?.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
    return null;
  }
}
